import type { ScheduleApiData } from "web-apps/company/components/schedule/types/schedule.types";

export interface ScheduleDayShiftsPageState {
  readonly data: ScheduleApiData;
  readonly hasMore: boolean;
  readonly page: number;
}

interface CreateScheduleDayShiftsPageStateParams {
  readonly data: ScheduleApiData;
  readonly page: number;
}

interface AppendScheduleDayShiftsPageParams {
  readonly current: ScheduleDayShiftsPageState;
  readonly next: ScheduleApiData;
}

function hasMoreScheduleDayShifts(data: ScheduleApiData): boolean {
  return data.items.length < data.total;
}

export function createScheduleDayShiftsPageState({
  data,
  page,
}: CreateScheduleDayShiftsPageStateParams): ScheduleDayShiftsPageState {
  return {
    data,
    hasMore: hasMoreScheduleDayShifts(data),
    page,
  };
}

export function appendScheduleDayShiftsPage({
  current,
  next,
}: AppendScheduleDayShiftsPageParams): ScheduleDayShiftsPageState {
  return createScheduleDayShiftsPageState({
    data: {
      items: [...current.data.items, ...next.items],
      total: next.total,
    },
    page: current.page + 1,
  });
}
